import { mapActions } from 'vuex'

export default {
  data () {
    return {
      showForm: false,
      timeOff: {}
    }
  },
  computed: {
    isApprover () {
      if (this.timeOff && this.timeOff.time_offs_settings) {
        const approverRoles = this.timeOff.time_offs_settings.approver_roles.map(function (role) {
          return role.name
        })
        const userRoles = this.getUser.user_roles.map(function (role) {
          return role.name
        })
        const userHasApproveRoles = approverRoles.filter(value => userRoles.includes(value))
        return userHasApproveRoles.length !== 0
      } else {
        return false
      }
    },
    isRequestor () {
      if (this.timeOff && this.timeOff.user) {
        return this.timeOff.user.id === this.getUser.id
      } else {
        return false
      }
    },
    isPending () {
      if (this.timeOff) {
        return this.timeOff.status === 'pending'
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions({
      setIsModalLoading: 'finances/setIsModalLoading'
    }),
    async loadTimeOff (id) {
      this.setIsModalLoading(true)
      return this.$api.timeOffs.showTimeOff(id)
        .then(({ data }) => {
          this.timeOff = data
          this.showForm = true
        })
        .catch(error => {
          if (error.response.status === 404) {
            this.$snotify.info(
              'This time off was declined or deleted',
              'Info',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.setIsModalLoading(false)
        })
    },
    approveTimeOff () {
      this.sendApproveRequest(this.timeOff.id, true)
        .then(async ({ data, status }) => {
          this.$snotify.success(
            'Time off successfully approved',
            'Approved',
            this.$store.state.snotify
          )
          await this.loadTimeOff(this.timeOff.id)
          this.$emit('updatedTimeOff', { data: this.timeOff, status })
          this.$emit('timeOffApproved')
          this.hideTimeOffsModal()
        })
        .catch(() => {})
    },
    declineTimeOff () {
      this.sendApproveRequest(this.timeOff.id, false)
        .then(async ({ data, status }) => {
          this.$snotify.info(
            'Time off declined',
            'Declined',
            this.$store.state.snotify
          )
          this.$emit('deletedTimeOff', { data: this.timeOff.id })
          this.$emit('timeOffApproved')
          this.hideTimeOffsModal()
        })
        .catch(() => {})
    },
    sendApproveRequest (id, approve) {
      this.setIsModalLoading(true)

      return this.$api.timeOffs.approveTimeOff(id, approve)
        .catch(error => {
          const errors = Object.values(error.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.setIsModalLoading(false)
        })
    },
    hideTimeOffsModal () {
      this.showForm = false
      this.setIsModalLoading(false)
    }
  }
}
